import {Component, forwardRef, Injector} from "@angular/core";
import {ColumnComponent} from "../../../framework/entity/grid/column.component";
import {
    ProductLineEditPageComponent
} from "../../../catalogue/product-line/product-line-edit-page/product-line-edit-page.component"
import {
    CompositeProductEditPageComponent
} from "../../../catalogue/composite-product/composite-product-edit-page/composite-product-edit-page.component"
import {AbstractColumnComponent} from "../../../framework/entity/grid/abstract-column.component";
import {MixAndMatchComplexity} from "../mix-and-match-complexity-analysis.data";
import {
    ProductLineCustomObjectEditPageComponent
} from "../../../custom-objects/custom-object/custom-object-edit-page/product-line-custom-object-edit-page.component";
import {EditMode} from "../../../framework/entity/edit/edit-page/edit-mode";

@Component({
    selector: "wbo-mix-and-match-inclusion-edit-link-column",
    templateUrl: "./mix-and-match-inclusion-edit-link-column.component.html",
    styleUrls: ["./mix-and-match-inclusion-edit-link-column.component.scss"],
    providers: [
        {
            provide: ColumnComponent,
            useExisting: forwardRef(() => MixAndMatchInclusionEditLinkColumnComponent),
            multi: true
        }
    ]
})
export class MixAndMatchInclusionEditLinkColumnComponent extends AbstractColumnComponent {
    EditMode = EditMode;
    ProductLineEditPageComponent = ProductLineEditPageComponent;
    CompositeProductEditPageComponent = CompositeProductEditPageComponent;
    ProductLineCustomObjectEditPageComponent = ProductLineCustomObjectEditPageComponent;
    MixAndMatchComplexity = MixAndMatchComplexity;

    constructor(injector: Injector) {
        super(injector);
        this.linkable = true;
        this.field = "name";
    }
}
